// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login-module__font-s-10___k1D3Z {
  font-size: 10px !important;
}

.Login-module__font-s-12___PYC8C {
  font-size: 12px !important;
}

.Login-module__font-s-13___H4wZh {
  font-size: 13px !important;
}

.Login-module__font-s-14___PyQfH {
  font-size: 14px !important;
}

.Login-module__font-s-15___aWxzO {
  font-size: 15px !important;
}

.Login-module__font-s-16___ruGjk {
  font-size: 16px !important;
}

.Login-module__font-s-18___BUyHB {
  font-size: 18px !important;
}

.Login-module__font-s-20___XCFQ0 {
  font-size: 20px !important;
}

.Login-module__font-s-22___Q2dZC {
  font-size: 22px !important;
}

.Login-module__font-s-28___hkMXV {
  font-size: 28px !important;
}

.Login-module__font-w-400___MvbII {
  font-weight: 400 !important;
}

.Login-module__font-w-500___bD8ha {
  font-weight: 500 !important;
}

.Login-module__font-w-600___JVWss {
  font-weight: 600 !important;
}

.Login-module__font-w-700___KPbKt {
  font-weight: 700 !important;
}

.Login-module__p-5___nekpc {
  padding: 5px !important;
}

.Login-module__p-12___ZW73D {
  padding: 12px !important;
}

.Login-module__p-16___Fj80n {
  padding: 16px !important;
}

.Login-module__p-30___UFtup {
  padding: 30px !important;
}

.Login-module__p-b-0___B93V7 {
  padding-bottom: 0 !important;
}

.Login-module__p-b-5___MiHA2 {
  padding-bottom: 5px !important;
}

.Login-module__p-b-10___ThDsP {
  padding-bottom: 10px !important;
}

.Login-module__p-b-12___A0ePh {
  padding-bottom: 12px !important;
}

.Login-module__p-b-16___FKIpm {
  padding-bottom: 16px !important;
}

.Login-module__p-b-18___sJwOK {
  padding-bottom: 18px !important;
}

.Login-module__p-b-20___SAryE {
  padding-bottom: 20px !important;
}

.Login-module__p-b-25___pRsEF {
  padding-bottom: 25px !important;
}

.Login-module__p-b-30___Kca3w {
  padding-bottom: 30px !important;
}

.Login-module__p-b-50___Ue2cL {
  padding-bottom: 50px !important;
}

.Login-module__p-t-0___YKGUM {
  padding-top: 0 !important;
}

.Login-module__p-t-12___Kb7f7 {
  padding-top: 12px !important;
}

.Login-module__p-t-16___PNdap {
  padding-top: 16px !important;
}

.Login-module__p-t-18___LhEYT {
  padding-top: 18px !important;
}

.Login-module__p-t-20___SvCXj {
  padding-top: 20px !important;
}

.Login-module__p-t-30___xWeMp {
  padding-top: 30px !important;
}

.Login-module__p-t-40___t83vl {
  padding-top: 40px !important;
}

.Login-module__p-t-50___M8yiB {
  padding-top: 50px !important;
}

.Login-module__p-l-20___r8Yum {
  padding-left: 20px !important;
}

.Login-module__p-l-30___USUdp {
  padding-left: 30px !important;
}

.Login-module__p-l-40___b3oC9 {
  padding-left: 40px !important;
}

.Login-module__p-r-16___hWylx {
  padding-right: 16px !important;
}

.Login-module__p-r-20___q7TNJ {
  padding-right: 20px !important;
}

.Login-module__p-r-30___uG0Mf {
  padding-right: 30px !important;
}

.Login-module__p-r-50___Ewjwc {
  padding-right: 50px !important;
}

.Login-module__p-r-60___bRLIv {
  padding-right: 60px !important;
}

.Login-module__m-b-1___C9V3k {
  margin-bottom: 1px !important;
}

.Login-module__m-b-2___iEMWA {
  margin-bottom: 2px !important;
}

.Login-module__m-b-6___iSO5G {
  margin-bottom: 6px !important;
}

.Login-module__m-b-8___JHQlM {
  margin-bottom: 8px !important;
}

.Login-module__m-b-10___uJCet {
  margin-bottom: 10px !important;
}

.Login-module__m-b-14___GIP_i {
  margin-bottom: 14px !important;
}

.Login-module__m-b-16___eRqgn {
  margin-bottom: 16px !important;
}

.Login-module__m-b-20___CTbnS {
  margin-bottom: 20px !important;
}

.Login-module__m-b-22___Si4T_ {
  margin-bottom: 22px !important;
}

.Login-module__m-b-24___wgvce {
  margin-bottom: 24px !important;
}

.Login-module__m-b-30___U7z7s {
  margin-bottom: 30px !important;
}

.Login-module__m-b-32___CLKFE {
  margin-bottom: 32px !important;
}

.Login-module__m-b-40___zjrRR {
  margin-bottom: 40px !important;
}

.Login-module__m-t-2___yXMhp {
  margin-top: 2px !important;
}

.Login-module__m-t-3___qLmkS {
  margin-top: 3px !important;
}

.Login-module__m-t-4___aqKDl {
  margin-top: 4px !important;
}

.Login-module__m-t-5___ZrUF9 {
  margin-top: 5px !important;
}

.Login-module__m-t-8___UadmS {
  margin-top: 8px !important;
}

.Login-module__m-t-10___in30J {
  margin-top: 10px !important;
}

.Login-module__m-t-15___W5FHO {
  margin-top: 15px !important;
}

.Login-module__m-t-16___CHYuf {
  margin-top: 16px !important;
}

.Login-module__m-t-20___jdLwZ {
  margin-top: 20px !important;
}

.Login-module__m-t-22___lFREe {
  margin-top: 22px !important;
}

.Login-module__m-t-30___m3Qdl {
  margin-top: 30px !important;
}

.Login-module__m-t-32___SELqM {
  margin-top: 32px !important;
}

.Login-module__m-l-auto___V8273 {
  margin-left: auto !important;
}

.Login-module__m-l-4___E4kEp {
  margin-left: 4px !important;
}

.Login-module__m-l-5___wdl23 {
  margin-left: 5px !important;
}

.Login-module__m-l-6___May8i {
  margin-left: 6px !important;
}

.Login-module__m-l-8___BWcZU {
  margin-left: 8px !important;
}

.Login-module__m-l-10___Q6JZf {
  margin-left: 10px !important;
}

.Login-module__m-l-16___DpuAs {
  margin-left: 16px !important;
}

.Login-module__m-l-20___Zdn6p {
  margin-left: 20px !important;
}

.Login-module__m-l-24___D1X8L {
  margin-left: 24px !important;
}

.Login-module__m-l-30___aqju1 {
  margin-left: 30px !important;
}

.Login-module__m-l-35___j1xE2 {
  margin-left: 35px !important;
}

.Login-module__m-l-40___LS5KM {
  margin-left: 40px !important;
}

.Login-module__m-r-8___eeicl {
  margin-right: 8px !important;
}

.Login-module__m-r-10___qvAUf {
  margin-right: 10px !important;
}

.Login-module__m-r-16___rzRDr {
  margin-right: 16px !important;
}

.Login-module__m-r-20____giXD {
  margin-right: 20px !important;
}

.Login-module__m-r-24___NH44Y {
  margin-right: 24px !important;
}

.Login-module__m-r-30___mvFf_ {
  margin-right: 30px !important;
}

.Login-module__m-r-40___NWvsq {
  margin-right: 40px !important;
}

.Login-module__border-r-3___vY7Nc {
  border-radius: 3px !important;
}

.Login-module__border-r-4___eMKzH {
  border-radius: 4px !important;
}

.Login-module__border-r-6___nHALC {
  border-radius: 6px !important;
}

.Login-module__border-r-10___UZLAn {
  border-radius: 10px !important;
}

.Login-module__border-r-12___GAtqk {
  border-radius: 12px !important;
}

.Login-module__border-r-16___pQ51V {
  border-radius: 16px !important;
}

.Login-module__border-r-50___zYMJP {
  border-radius: 50% !important;
}

.Login-module__primary-border___C6kaU {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Login-module__primary-border-b___n4Tl5 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Login-module__primary-border-t___WrsjH {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Login-module__primary-border-l___TieXb {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Login-module__primary-border-r___Sl6zH {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Login-module__secondary-border___YP49h {
  border: 1px solid #637768;
}

.Login-module__secondary-border-b___RnREf {
  border-bottom: 1px solid #637768;
}

.Login-module__secondary-border-t___L6vwQ {
  border-top: 1px solid #637768;
}

.Login-module__secondary-border-l___lsnml {
  border-left: 1px solid #637768;
}

.Login-module__secondary-border-r___KWbdw {
  border-right: 1px solid #637768;
}

.Login-module__gap-0___lE4Qd {
  gap: 0 !important;
}

.Login-module__gap-2___TR91i {
  gap: 2px !important;
}

.Login-module__gap-4___qobki {
  gap: 4px !important;
}

.Login-module__gap-5___eNyoL {
  gap: 5px !important;
}

.Login-module__gap-6___Cif5n {
  gap: 6px !important;
}

.Login-module__gap-8___srMFb {
  gap: 8px !important;
}

.Login-module__gap-10___FnNoh {
  gap: 10px !important;
}

.Login-module__gap-12___fNo3a {
  gap: 12px !important;
}

.Login-module__gap-14___vG4nx {
  gap: 14px !important;
}

.Login-module__gap-16___wn8W9 {
  gap: 16px !important;
}

.Login-module__gap-18___SENQg {
  gap: 18px !important;
}

.Login-module__gap-20___zdQWy {
  gap: 20px !important;
}

.Login-module__gap-24___lGjoz {
  gap: 24px !important;
}

.Login-module__gap-26___kiy96 {
  gap: 26px !important;
}

.Login-module__gap-30___AzVdo {
  gap: 30px !important;
}

.Login-module__gap-32___LP29G {
  gap: 32px !important;
}

.Login-module__gap-40___F6fX3 {
  gap: 40px !important;
}

.Login-module__gap-50___CBX73 {
  gap: 50px !important;
}

.Login-module__flex-1___R7fsM {
  flex: 1;
}

.Login-module__flex-none___r5dyU {
  flex: none !important;
}

.Login-module__flex-column___XW80j {
  display: flex;
  flex-direction: column !important;
}

.Login-module__flex-row___hJPNc {
  display: flex;
  flex-direction: row !important;
}

.Login-module__vertically-centered___v3NUm {
  display: flex;
  align-items: center !important;
}

.Login-module__horizontally-centered___L_PYI {
  display: flex;
  justify-content: center !important;
}

.Login-module__horizontally-end___wPQdV {
  display: flex;
  justify-content: end !important;
}

.Login-module__vertically-start___WsHZZ {
  display: flex;
  align-items: start !important;
}

.Login-module__space-between___faMN_ {
  display: flex;
  justify-content: space-between !important;
}

.Login-module__flex-wrap___xaL2i {
  flex-wrap: wrap !important;
}

.Login-module__height-100___QSYqO {
  height: 100%;
}

.Login-module__width-50___PjlGp {
  width: 50% !important;
}

.Login-module__width-100___cYEGM {
  width: 100%;
}

.Login-module__cursor-pointer___iXOzE {
  cursor: pointer;
}

.Login-module__cursor-not-allowed___HUCcw {
  cursor: not-allowed !important;
}

.Login-module__absolute-centered___SBrIq {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Login-module__absolute___C_IrK {
  position: absolute;
}

.Login-module__relative___iF5WI {
  position: relative;
}

.Login-module__fixed___HzhMU {
  position: fixed;
}

.Login-module__visible___UbETv {
  opacity: 1;
}

.Login-module__invisible___qQriQ {
  opacity: 0;
}

.Login-module__col-90___dNGyz {
  width: 90% !important;
}

.Login-module__col-auto___NSI6t {
  width: auto !important;
}

.Login-module__medical-tabs___cYXf2 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Login-module__medical-table-new___Qgid7 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Login-module__medical-table-new___Qgid7:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Login-module__medical-table-new___Qgid7::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Login-module__medical-table-new___Qgid7::-webkit-scrollbar-track {
  display: none;
}
.Login-module__medical-table-new___Qgid7.Login-module__no-pagination___spJNe {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Login-module__medical-table-new___Qgid7.Login-module__no-pagination___spJNe:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Login-module__medical-table-new___Qgid7.Login-module__no-pagination___spJNe::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Login-module__medical-table-new___Qgid7.Login-module__no-pagination___spJNe::-webkit-scrollbar-track {
  display: none;
}

.Login-module__medical-table-empty___Q4nV5 {
  padding: 14px 40px !important;
}

.Login-module__icon-btn___qKzNQ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Login-module__search-icon___VKV1_ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Login-module__disable-select___NFMl0 {
  user-select: none;
}

.Login-module__break-word___dZMCX {
  word-break: break-word;
}

.Login-module__popup-clear-btn___dmUjw {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Login-module__scroll-m-b-20___SCRC4 {
  scroll-margin-bottom: 20px;
}

.Login-module__container___PJ0AS {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
}
.Login-module__container___PJ0AS .Login-module__logoContainer___GjwRd {
  display: flex;
  flex-direction: row;
  padding: 4vh 4vw;
}
.Login-module__container___PJ0AS .Login-module__logoContainer___GjwRd .Login-module__logo___k7OAG {
  width: 36px;
  height: 36px;
  object-fit: contain;
}
.Login-module__container___PJ0AS .Login-module__logoContainer___GjwRd .Login-module__logoText___wuCPe {
  font-family: "Work Sans";
  font-weight: 400;
  color: #375844;
  font-size: 22px;
  padding-left: 1vw;
  align-self: center;
}
.Login-module__container___PJ0AS .Login-module__formContainer___aXd5i {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
.Login-module__container___PJ0AS .Login-module__formContainer___aXd5i .Login-module__form___i44Lx {
  max-height: 85vh;
  width: 400px;
  padding: 3vw;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
}
.Login-module__container___PJ0AS .Login-module__formContainer___aXd5i .Login-module__form___i44Lx .Login-module__header___mQtp9 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.Login-module__container___PJ0AS .Login-module__formContainer___aXd5i .Login-module__form___i44Lx .Login-module__header___mQtp9 .Login-module__headerText___O7NM6 {
  font-family: var(--font-family);
  font-weight: 400;
  color: #375844;
  font-size: 22px;
  font-weight: 700;
}
.Login-module__container___PJ0AS .Login-module__formContainer___aXd5i .Login-module__form___i44Lx .Login-module__header___mQtp9 .Login-module__subheaderText___dB9Uj {
  font-family: var(--font-family);
  font-weight: 400;
  color: #637768;
  font-size: 16px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/Login/Login.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA8pBJ;AA5pBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA8pBN;AA3pBI;EEOF,wBFNsB;EEOtB,gBCzBQ;EHmBJ,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA8pBN;AA1pBE;EACE,aAAA;EACA,OAAA;EACA,mBAAA;EACA,uBAAA;AA4pBJ;AA1pBI;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,wCAAA;AA4pBN;AA1pBM;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA4pBR;AA1pBQ;EErBN,+BApBO;EAqBP,gBAFmD;EFwB3C,cAAA;EACA,eAAA;EACA,gBAAA;AA6pBV;AA1pBQ;EE5BN,+BApBO;EAqBP,gBAFmD;EF+B3C,cAAA;EACA,eAAA;EACA,gBAAA;AA6pBV","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  height: 100vh;\n\n  .logoContainer {\n    display: flex;\n    flex-direction: row;\n    padding: 4vh 4vw;\n\n    .logo {\n      width: 36px;\n      height: 36px;\n      object-fit: contain;\n    }\n\n    .logoText {\n      @include get-font('Work Sans', $regular);\n      color: get-color(greenNew, dark);\n      font-size: 22px;\n      padding-left: 1vw;\n      align-self: center;\n    }\n  }\n\n  .formContainer {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n\n    .form {\n      max-height: 85vh;\n      width: 400px;\n      padding: 3vw;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);\n\n      .header {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: center;\n        gap: 10px;\n\n        .headerText {\n          @include get-font();\n          color: get-color(greenNew, dark);\n          font-size: 22px;\n          font-weight: 700;\n        }\n\n        .subheaderText {\n          @include get-font();\n          color: get-color(greenNew, medium-dark);\n          font-size: 16px;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Login-module__font-s-10___k1D3Z`,
	"fontS12": `Login-module__font-s-12___PYC8C`,
	"fontS13": `Login-module__font-s-13___H4wZh`,
	"fontS14": `Login-module__font-s-14___PyQfH`,
	"fontS15": `Login-module__font-s-15___aWxzO`,
	"fontS16": `Login-module__font-s-16___ruGjk`,
	"fontS18": `Login-module__font-s-18___BUyHB`,
	"fontS20": `Login-module__font-s-20___XCFQ0`,
	"fontS22": `Login-module__font-s-22___Q2dZC`,
	"fontS28": `Login-module__font-s-28___hkMXV`,
	"fontW400": `Login-module__font-w-400___MvbII`,
	"fontW500": `Login-module__font-w-500___bD8ha`,
	"fontW600": `Login-module__font-w-600___JVWss`,
	"fontW700": `Login-module__font-w-700___KPbKt`,
	"p5": `Login-module__p-5___nekpc`,
	"p12": `Login-module__p-12___ZW73D`,
	"p16": `Login-module__p-16___Fj80n`,
	"p30": `Login-module__p-30___UFtup`,
	"pB0": `Login-module__p-b-0___B93V7`,
	"pB5": `Login-module__p-b-5___MiHA2`,
	"pB10": `Login-module__p-b-10___ThDsP`,
	"pB12": `Login-module__p-b-12___A0ePh`,
	"pB16": `Login-module__p-b-16___FKIpm`,
	"pB18": `Login-module__p-b-18___sJwOK`,
	"pB20": `Login-module__p-b-20___SAryE`,
	"pB25": `Login-module__p-b-25___pRsEF`,
	"pB30": `Login-module__p-b-30___Kca3w`,
	"pB50": `Login-module__p-b-50___Ue2cL`,
	"pT0": `Login-module__p-t-0___YKGUM`,
	"pT12": `Login-module__p-t-12___Kb7f7`,
	"pT16": `Login-module__p-t-16___PNdap`,
	"pT18": `Login-module__p-t-18___LhEYT`,
	"pT20": `Login-module__p-t-20___SvCXj`,
	"pT30": `Login-module__p-t-30___xWeMp`,
	"pT40": `Login-module__p-t-40___t83vl`,
	"pT50": `Login-module__p-t-50___M8yiB`,
	"pL20": `Login-module__p-l-20___r8Yum`,
	"pL30": `Login-module__p-l-30___USUdp`,
	"pL40": `Login-module__p-l-40___b3oC9`,
	"pR16": `Login-module__p-r-16___hWylx`,
	"pR20": `Login-module__p-r-20___q7TNJ`,
	"pR30": `Login-module__p-r-30___uG0Mf`,
	"pR50": `Login-module__p-r-50___Ewjwc`,
	"pR60": `Login-module__p-r-60___bRLIv`,
	"mB1": `Login-module__m-b-1___C9V3k`,
	"mB2": `Login-module__m-b-2___iEMWA`,
	"mB6": `Login-module__m-b-6___iSO5G`,
	"mB8": `Login-module__m-b-8___JHQlM`,
	"mB10": `Login-module__m-b-10___uJCet`,
	"mB14": `Login-module__m-b-14___GIP_i`,
	"mB16": `Login-module__m-b-16___eRqgn`,
	"mB20": `Login-module__m-b-20___CTbnS`,
	"mB22": `Login-module__m-b-22___Si4T_`,
	"mB24": `Login-module__m-b-24___wgvce`,
	"mB30": `Login-module__m-b-30___U7z7s`,
	"mB32": `Login-module__m-b-32___CLKFE`,
	"mB40": `Login-module__m-b-40___zjrRR`,
	"mT2": `Login-module__m-t-2___yXMhp`,
	"mT3": `Login-module__m-t-3___qLmkS`,
	"mT4": `Login-module__m-t-4___aqKDl`,
	"mT5": `Login-module__m-t-5___ZrUF9`,
	"mT8": `Login-module__m-t-8___UadmS`,
	"mT10": `Login-module__m-t-10___in30J`,
	"mT15": `Login-module__m-t-15___W5FHO`,
	"mT16": `Login-module__m-t-16___CHYuf`,
	"mT20": `Login-module__m-t-20___jdLwZ`,
	"mT22": `Login-module__m-t-22___lFREe`,
	"mT30": `Login-module__m-t-30___m3Qdl`,
	"mT32": `Login-module__m-t-32___SELqM`,
	"mLAuto": `Login-module__m-l-auto___V8273`,
	"mL4": `Login-module__m-l-4___E4kEp`,
	"mL5": `Login-module__m-l-5___wdl23`,
	"mL6": `Login-module__m-l-6___May8i`,
	"mL8": `Login-module__m-l-8___BWcZU`,
	"mL10": `Login-module__m-l-10___Q6JZf`,
	"mL16": `Login-module__m-l-16___DpuAs`,
	"mL20": `Login-module__m-l-20___Zdn6p`,
	"mL24": `Login-module__m-l-24___D1X8L`,
	"mL30": `Login-module__m-l-30___aqju1`,
	"mL35": `Login-module__m-l-35___j1xE2`,
	"mL40": `Login-module__m-l-40___LS5KM`,
	"mR8": `Login-module__m-r-8___eeicl`,
	"mR10": `Login-module__m-r-10___qvAUf`,
	"mR16": `Login-module__m-r-16___rzRDr`,
	"mR20": `Login-module__m-r-20____giXD`,
	"mR24": `Login-module__m-r-24___NH44Y`,
	"mR30": `Login-module__m-r-30___mvFf_`,
	"mR40": `Login-module__m-r-40___NWvsq`,
	"borderR3": `Login-module__border-r-3___vY7Nc`,
	"borderR4": `Login-module__border-r-4___eMKzH`,
	"borderR6": `Login-module__border-r-6___nHALC`,
	"borderR10": `Login-module__border-r-10___UZLAn`,
	"borderR12": `Login-module__border-r-12___GAtqk`,
	"borderR16": `Login-module__border-r-16___pQ51V`,
	"borderR50": `Login-module__border-r-50___zYMJP`,
	"primaryBorder": `Login-module__primary-border___C6kaU`,
	"primaryBorderB": `Login-module__primary-border-b___n4Tl5`,
	"primaryBorderT": `Login-module__primary-border-t___WrsjH`,
	"primaryBorderL": `Login-module__primary-border-l___TieXb`,
	"primaryBorderR": `Login-module__primary-border-r___Sl6zH`,
	"secondaryBorder": `Login-module__secondary-border___YP49h`,
	"secondaryBorderB": `Login-module__secondary-border-b___RnREf`,
	"secondaryBorderT": `Login-module__secondary-border-t___L6vwQ`,
	"secondaryBorderL": `Login-module__secondary-border-l___lsnml`,
	"secondaryBorderR": `Login-module__secondary-border-r___KWbdw`,
	"gap0": `Login-module__gap-0___lE4Qd`,
	"gap2": `Login-module__gap-2___TR91i`,
	"gap4": `Login-module__gap-4___qobki`,
	"gap5": `Login-module__gap-5___eNyoL`,
	"gap6": `Login-module__gap-6___Cif5n`,
	"gap8": `Login-module__gap-8___srMFb`,
	"gap10": `Login-module__gap-10___FnNoh`,
	"gap12": `Login-module__gap-12___fNo3a`,
	"gap14": `Login-module__gap-14___vG4nx`,
	"gap16": `Login-module__gap-16___wn8W9`,
	"gap18": `Login-module__gap-18___SENQg`,
	"gap20": `Login-module__gap-20___zdQWy`,
	"gap24": `Login-module__gap-24___lGjoz`,
	"gap26": `Login-module__gap-26___kiy96`,
	"gap30": `Login-module__gap-30___AzVdo`,
	"gap32": `Login-module__gap-32___LP29G`,
	"gap40": `Login-module__gap-40___F6fX3`,
	"gap50": `Login-module__gap-50___CBX73`,
	"flex1": `Login-module__flex-1___R7fsM`,
	"flexNone": `Login-module__flex-none___r5dyU`,
	"flexColumn": `Login-module__flex-column___XW80j`,
	"flexRow": `Login-module__flex-row___hJPNc`,
	"verticallyCentered": `Login-module__vertically-centered___v3NUm`,
	"horizontallyCentered": `Login-module__horizontally-centered___L_PYI`,
	"horizontallyEnd": `Login-module__horizontally-end___wPQdV`,
	"verticallyStart": `Login-module__vertically-start___WsHZZ`,
	"spaceBetween": `Login-module__space-between___faMN_`,
	"flexWrap": `Login-module__flex-wrap___xaL2i`,
	"height100": `Login-module__height-100___QSYqO`,
	"width50": `Login-module__width-50___PjlGp`,
	"width100": `Login-module__width-100___cYEGM`,
	"cursorPointer": `Login-module__cursor-pointer___iXOzE`,
	"cursorNotAllowed": `Login-module__cursor-not-allowed___HUCcw`,
	"absoluteCentered": `Login-module__absolute-centered___SBrIq`,
	"absolute": `Login-module__absolute___C_IrK`,
	"relative": `Login-module__relative___iF5WI`,
	"fixed": `Login-module__fixed___HzhMU`,
	"visible": `Login-module__visible___UbETv`,
	"invisible": `Login-module__invisible___qQriQ`,
	"col90": `Login-module__col-90___dNGyz`,
	"colAuto": `Login-module__col-auto___NSI6t`,
	"medicalTabs": `Login-module__medical-tabs___cYXf2`,
	"medicalTableNew": `Login-module__medical-table-new___Qgid7`,
	"noPagination": `Login-module__no-pagination___spJNe`,
	"medicalTableEmpty": `Login-module__medical-table-empty___Q4nV5`,
	"iconBtn": `Login-module__icon-btn___qKzNQ`,
	"searchIcon": `Login-module__search-icon___VKV1_`,
	"disableSelect": `Login-module__disable-select___NFMl0`,
	"breakWord": `Login-module__break-word___dZMCX`,
	"popupClearBtn": `Login-module__popup-clear-btn___dmUjw`,
	"scrollMB20": `Login-module__scroll-m-b-20___SCRC4`,
	"container": `Login-module__container___PJ0AS`,
	"logoContainer": `Login-module__logoContainer___GjwRd`,
	"logo": `Login-module__logo___k7OAG`,
	"logoText": `Login-module__logoText___wuCPe`,
	"formContainer": `Login-module__formContainer___aXd5i`,
	"form": `Login-module__form___i44Lx`,
	"header": `Login-module__header___mQtp9`,
	"headerText": `Login-module__headerText___O7NM6`,
	"subheaderText": `Login-module__subheaderText___dB9Uj`
};
module.exports = ___CSS_LOADER_EXPORT___;
